import React, { PureComponent } from 'react'
import { Col, Card, Row } from 'reactstrap'
import WizardFormOne from './WizardFormOne'
import WizardFormTwo from './WizardFormTwo'
import WizardFormThree from './WizardFormThree'
import uuid from 'uuid'

import { companyProfileAssessmentData } from '../../../utils/mockData'

import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { signout } from '../../../redux/actions/userActions'

const profileData = companyProfileAssessmentData()

const GetQuestions = gql`query getAssessments {
  assessment(id: 2){
    id
    title
    description
    lastUpdated
    dateCreated
    questions{
      id
      question
      category
      helpText
      answers
      order
      active
      lastUpdated
      dateCreated
    }
  }
}`

class WizardForm extends PureComponent {
  constructor(props) {
    super(props)
    this.nextPage = this.nextPage.bind(this)
    this.previousPage = this.previousPage.bind(this)
    this.updateAssessmentStatus = this.updateAssessmentStatus.bind(this)
    this.updateQueryErrorStatus = this.updateQueryErrorStatus.bind(this)
    this.state = {
      page: 1,
      assessment: null,
      steps: [],
      loading: true,
      loaded: false,
      queryError: null
    }
  }

  componentDidMount () {
    this.setState({
      page: profileData.progress
    })
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.assessment !== this.state.assessment) {
      this.setState({
        loaded: true,
        loading: false
      })
      this.getSteps()
    }
  }

  componentWillMount () {

  }

  updateAssessmentStatus (data) {
    return (
      <div>
        {data.allAssessmentQuestionsByAssessmentId ? this.setState({ assessment: data }) : null}
      </div>
    )
  }

  updateQueryErrorStatus (error) {
    return new Promise((resolve, reject) => {
      this.setState({ queryError: error }, () => {
        resolve()
      })
    })
  }

  nextPage () {
    this.setState({ page: this.state.page + 1 })
  }

  previousPage () {
    this.setState({ page: this.state.page - 1 })
  }

  getSteps () {
    const stepsForState = []
    const category = this.state.assessment.map(assess => {
      return assess.category.toLowerCase()
    })

    const stepsSet = new Set(category)
    stepsSet.forEach(step => {
      stepsForState.push(step)
    })

    this.setState({ steps: stepsForState })
  }

  renderSteps (step, index, key) {
    const { page } = this.state

    return (
      <div
        key={key}
        onClick={() => this.setState({ page: index + 1 })}
        className={`pointer-element wizard__step${page === index + 1 ? ' wizard__step--active' : ''}`}>
        <p>{step}</p>
      </div>
    )
  }

  renderForms () {
    const { page, steps, assessment } = this.state
    const length = steps.length
    const { onSubmit } = this.props

    return <div>
      {
        steps.map((step, index) => {
          const questions = assessment.filter(data => {
            return data.category.toLowerCase() === step
          })

          return index === 0
            ? page === index + 1 && <WizardFormOne data={questions} onSubmit={this.nextPage} key={uuid()} />
            : index < length - 1
              ? page === index + 1 &&
              <WizardFormTwo data={questions} previousPage={this.previousPage} onSubmit={this.nextPage} key={uuid()} />
              : page === index + 1 &&
              <WizardFormThree data={questions} previousPage={this.previousPage} onSubmit={onSubmit} key={uuid()} />
        })
      }
    </div>
  }

  signoutUser () {
    this.props.signout()
    this.props.history.push('/')
  }

  render () {
    // console.log(this.state.assessment)
    const { steps, loaded } = this.state
    return (
      <Row>
        {!loaded && <div className={`custom_load load${this.state.loading ? '' : ' loaded'}`}>
          <div className='load__icon-wrap'>
            <svg className='load__icon'>
              <path fill='#2d9aa6' d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z' />
            </svg>
          </div>
        </div>}
        <Col md={12} lg={12}>
          <Card>
            <div className='wizard'>
              <div className='wizard__steps'>
                {
                  steps
                    ? steps.map((step, index) => {
                      return this.renderSteps(step, index, uuid())
                    })
                    : null
                }
              </div>
              <div className='wizard__form-wrapper'>
                {
                  this.renderForms()
                }
              </div>
            </div>
          </Card>
        </Col>
        {/**
          * This is the Apollo component used to make queries.
          * This component(as we are using it) accepts two props at the moment.
          * The query prop that holds the query and fetchPolicy prop that determines
          * how the component interacts with Apollo cache data.
          */}
        <Query query={GetQuestions} fetchPolicy={'network-only'}
          /**
           * This function is called on completion of a resquest (Not Necessary)
           */
          onCompleted={() => { console.log('Done') }}
          /**
           * This function is called when an error is thrown.
           * It calls the updateQueryErrorStatus method which
           * updates the queryError state and returns a promise
           */
          onError={(e) => {
            if (e.networkError) {
              if (e.networkError['statusCode'] === 401) {
                this.signoutUser()
              }
            } else {
              console.log(e.message)
              this.signoutUser()
            }
          }}
        >
          {({ loading, error, data, refetch, networkStatus }) => {
            // console.log(`Network Status: ${networkStatus}`)
            // If the response hasn't returned yet then return null
            if (loading) return null
            /**
             * If an error is thrown then the updateQueryErrorStatus
             * method is called which updates the queryError state
             * and returns a promise
             */
            if (error) {
              console.log(`ERROR!! > ${error}`)
              this.updateQueryErrorStatus(error.message).then(() => {
                console.log('error message:' + this.state.queryError)
              })
            }// alert(error);

            /**
             * If (in one of the requests) there are no errors then a div
             * element will be return which will check the response data.
             * If the response data is not null and there are no errors
             * then the assessment state will be updated.
             */
            return (
              <div>
                {data.assessment
                  ? (this.state.queryError ? console.log('There is an error')
                    : this.setState({ assessment: data.assessment.questions })) : null}

              </div>
            )
          }}
        </Query>
      </Row>
    )
  }
}

export default connect(null, { signout })(withRouter(WizardForm))



// WEBPACK FOOTER //
// ./src/components/assessment/components/WizardForm.js